import axios from 'axios';
import { ApiService } from '../../../shared/service/Apiservice';
import { environment } from '../../../shared/enviroment/environment';
import {
  ApiResponse,
  AvailableCoinsForPurchase,
  BuildCoinsBalance,
  BuildCoinsStats,
  BuildCoinsTransactionHistory,
  EarningOpportunity,
  PurchaseEligibility,
  UsageGuidelines,
} from '../dto/BuildCoins.dto';

class BuildCoinsService {
  private apiRootServer = environment.api.apiRootServer;
  private __ApiService: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__ApiService = new ApiService(axiosInstance, this.apiRootServer);
  }

  // Get user's Build Coins balance
  async getBalance(): Promise<ApiResponse<BuildCoinsBalance>> {
    return this.__ApiService.getRequest('build-coins/balance', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  // Get user's Build Coins stats
  async getStats(): Promise<ApiResponse<BuildCoinsStats>> {
    return this.__ApiService.getRequest('build-coins/stats', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  // Get user's transaction history
  async getTransactionHistory(page = 1, limit = 20): Promise<ApiResponse<BuildCoinsTransactionHistory>> {
    return this.__ApiService.getRequest('build-coins/transactions', { page, limit }, {
      apiRoot: this.apiRootServer,
    });
  }

  // Get available Build Coins for a purchase amount
  async getAvailableCoinsForPurchase(orderAmount: number): Promise<ApiResponse<AvailableCoinsForPurchase>> {
    return this.__ApiService.getRequest('build-coins/available-for-purchase', { orderAmount }, {
      apiRoot: this.apiRootServer,
    });
  }

  // Check if user can use Build Coins for purchase
  async checkPurchaseEligibility(amount: number): Promise<ApiResponse<PurchaseEligibility>> {
    return this.__ApiService.postRequest('build-coins/check-purchase-eligibility', { amount }, {
      apiRoot: this.apiRootServer,
    });
  }

  // Earning opportunities
  async getEarningOpportunities(): Promise<ApiResponse<EarningOpportunity[]>> {
    return this.__ApiService.getRequest('build-coins/earning-opportunities', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  // Usage guidelines
  async getUsageGuidelines(): Promise<ApiResponse<UsageGuidelines>> {
    return this.__ApiService.getRequest('build-coins/usage-guidelines', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}

const buildCoinsService = new BuildCoinsService();
export default buildCoinsService;
